module.exports = __webpack_public_path__ + "img/socolow-bulletin-75-contending-with-climate-change-the-next-25-years-final-dec-10-2020.pdf";